<ng-container *ngIf="visivel">

  <!-- destaque: topo do hub -->
  <section class="bn bn--destaque" *ngIf="formato === 'destaque' && !garantido" aria-label="Oferta de ativação">
    <span class="bn-ic"><i class="fas fa-gift"></i></span>
    <div class="bn-corpo">
      <span class="bn-rot">Oferta de ativação</span>
      <b class="bn-valor">{{ beneficio }}</b>
      <span class="bn-onde">{{ periodo }}</span>
      <span class="bn-meta"><b>{{ textoFaltam }}</b> · {{ textoDias }}</span>
      <span class="bn-como">Como ganhar: conclua o pedido de teste ou receba seu primeiro pedido de verdade antes de acabar o teste grátis. O benefício entra automaticamente na cobrança do plano.</span>
      <small class="bn-como" *ngIf="depois">{{ depois }}</small>
    </div>
  </section>

  <section class="bn bn--destaque bn--ok" *ngIf="formato !== 'faixa' && formato !== 'cartao' && garantido">
    <span class="bn-ic"><i class="fas fa-check"></i></span>
    <div class="bn-corpo">
      <span class="bn-rot">Benefício garantido</span>
      <b class="bn-valor">{{ beneficio }}</b>
      <span class="bn-onde">{{ periodo }}. Aplicado automaticamente na cobrança do plano.</span>
      <small class="bn-como" *ngIf="depois">{{ depois }}</small>
    </div>
  </section>

  <!-- faixa: alto de cada passo -->
  <div class="bn bn--faixa" *ngIf="formato === 'faixa' && !garantido">
    <i class="fas fa-gift"></i>
    <span>Conclua os primeiros passos{{ textoAte }} e garanta <b>{{ beneficio }}</b> {{ periodo }}.</span>
  </div>

  <!-- cartão: ao lado do título das telas de pergunta -->
  <div class="bn bn--cartao" *ngIf="formato === 'cartao' && !garantido">
    <span class="bn-cartao-ic"><i class="fas fa-gift" aria-hidden="true"></i></span>
    <div>
      <div class="bn-cartao-topo">
        <span class="bn-cartao-rot">Bônus de ativação</span>
        <span class="bn-cartao-prazo" *ngIf="prazo">{{ textoExpira }}</span>
      </div>
      <span>{{ textoConclua }} e ganhe <b class="bn-cartao-valor">{{ valor }} OFF</b> na sua primeira mensalidade.</span>
    </div>
  </div>

  <!-- final: junto do botão de concluir o pedido de teste -->
  <div class="bn bn--final" *ngIf="formato === 'final' && !garantido">
    <i class="fas fa-gift"></i>
    <span>Concluindo agora você garante <b>{{ beneficio }}</b> {{ periodo }}.</span>
  </div>
  <small class="bn-como" *ngIf="depois && !garantido && (formato === 'faixa' || formato === 'final')">{{ depois }}</small>
</ng-container>
